import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// state
const state = {
    isloading: false, // 是否加载中
    userinfo: {}, // 登录信息
    bindlist: {
        show: false,
        list: []
    },
    // 绑定列表
    mylogin: {    // 当前登录
        phone: '',
        timer: null,
        num: 60,
        sending: false,
        show:false
    },
    mybind: {   //当前绑定
        timer1: null,
        timer2: null,
        num: 60,
        sending: false,
        show: false,
        info: {},
        vcode: ''
    }
}

// actions
const actions = {
    setloading: (context, payload) => context.commit('SETLOADING', payload),
    setUser: (context, payload) => context.commit('SETUSER', payload),
    setBinds: (context, payload) => context.commit('SETBINDS', payload),
    loginShow: (context, payload) => context.commit('LOGINSHOW'),
    bindsShow: (context, payload) => context.commit('BINDSSHOW')
}

// mutations
const mutations = {
    SETLOADING: (state, payload) => {
        state.isloading = payload;
        if (payload == true) {
            setTimeout(() => {
                state.isloading = false;
            }, 3200)
        }
    },
    SETUSER: (state, payload) => {
        state.userinfo = payload;
    },
    SETBINDS: (state, payload) => {
        state.bindlist.list = payload;
    },
    LOGINSHOW: (state) => {
        state.mylogin.show = true;
        state.mylogin.code = "";
    },
    BINDSSHOW: (state) => {
        state.bindlist.show = true;
    }
}

const store = new Vuex.Store({
    state,
    mutations,
    actions
})

export default store